import AppMainSettings from './app-main-settings';

export default AppMainSettings;
